module.exports = __webpack_public_path__ + "static/media/IMG_3822.9ff39188.JPG";